import { HttpBackend } from '@angular/common/http';
import { TranslateScopes } from '@cloud-twin-v2/cloud-twin-shared/core/translate-scopes';
import { commonTranslationResources } from '@common-modules/translate/common-translation-resources';
import { TranslateLoader } from '@ngx-translate/core';
import { CustomMultiTranslateHttpLoader } from 'src/app/custom-multi-translate-http-loader';

const buildI18nResources = (items: string[]) =>
  items.map((item) => ({ prefix: `assets/i18n/${item}/`, suffix: '.json' }));

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpBackend) {
  return new CustomMultiTranslateHttpLoader(http, [
    ...buildI18nResources([
      TranslateScopes.Core,
      TranslateScopes.MainLayout,
      TranslateScopes.MasterOperator,
      TranslateScopes.Navigations,
      TranslateScopes.ModelVersion,
      TranslateScopes.Telemetry,
      TranslateScopes.CtMap,
      TranslateScopes.WlmSecurity,
      TranslateScopes.Workspaces,
      TranslateScopes.WlmNavigation,
    ]),
    ...commonTranslationResources,
  ]);
}

export const cloudTwinTranslateModuleConfigurator = {
  loader: {
    provide: TranslateLoader,
    useFactory: HttpLoaderFactory,
    deps: [HttpBackend],
  },
};
